import { nl2br } from '../../../utils';

export const DataContainer = ({ data }: { data: object | undefined }) => {
  if (!data) return null;

  const dataClassName = (data: object | undefined) => {
    if (typeof data === 'number' || typeof data === 'boolean') {
      return 'text-right';
    }
    return 'text-left';
  };

  const formatData = (data: object | undefined) => {
    if (!data) return '';

    if (typeof data === 'number' || typeof data === 'boolean') {
      return data;
    }
    if (typeof data === 'string') {
      return nl2br(data);
    }
    // apply nl-2-br
    const dataString = JSON.stringify(data, null, 2);
    return nl2br(dataString);
  };

  // Convert the data to a list if it is an array
  if (Array.isArray(data)) {
    const dataArray = data as object[];
    return (
      <table cellPadding={0} className='table table-sm table-bordered background-ThemeBgLight border border-ThemeBgExtradark mb-0'>
        <thead className='background-ThemeBgDark strong'>
          <tr>
            <td>Response</td>
          </tr>
        </thead>
        <tbody>
          {dataArray.map((item, index) => <tr key={index}><td>{formatData(item)}</td></tr>)}
        </tbody>
      </table>
    );
  }

  // Convert the data to a table if it is an object
  if (typeof data === 'object') {
    const keys = Object.keys(data);
    return (
      <table className='table table-sm table-bordered background-ThemeBgLight border border-ThemeBgExtradark mb-0'>
        <thead className='background-ThemeBgDark strong'>
          <tr>
            <td></td><td>Response</td>
          </tr>
        </thead>
        <tbody>
          {keys.map((key) => <tr key={key}><td>{key}</td><td className={dataClassName(data[key as keyof typeof data])}>{formatData(data[key as keyof typeof data])}</td></tr>)}
        </tbody>
      </table>
    );
  }

  return <code>{JSON.stringify(data, null, 2)}</code>;
};

